import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class AdvisorPortalAdvisorProUpgradeStarted extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ADVISOR_PORTAL_ADVISOR_PRO_UPGRADE_STARTED;

  entryPoint: string;

  constructor(entryPoint: string) {
    super();

    this.entryPoint = entryPoint;
  }
}
